var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Error(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 810,
    height: 445.103,
    viewBox: "0 0 810 445.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1393",
    "data-name": "Rectangle 1393",
    width: 810,
    height: 439,
    transform: "translate(553 74)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00080d",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    transform: "translate(-555 -173.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2513",
    "data-name": "Group 2513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_51",
    "data-name": "Mask Group 51",
    transform: "translate(2 106)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 379,
    cy: 257,
    rx: 379,
    ry: 257,
    transform: "translate(579 115)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 158.532,
    cy: 7.98,
    rx: 158.532,
    ry: 7.98,
    transform: "translate(810.074 602.36)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(861.45 304.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68444",
    "data-name": "Path 68444",
    d: "M1879.21,77.539v263.7a7.465,7.465,0,0,1-7.469,7.469H1671.054a7.465,7.465,0,0,1-7.469-7.469v-220.5h44.485a7.472,7.472,0,0,0,7.469-7.469V70.07h156.2A7.472,7.472,0,0,1,1879.21,77.539Z",
    transform: "translate(-1663.585 -70.07)",
    fill: "#fff",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68445",
    "data-name": "Path 68445",
    d: "M1715.539,70.07v43.2a7.472,7.472,0,0,1-7.469,7.469h-44.485Z",
    transform: "translate(-1663.585 -70.07)",
    fill: "#fff",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_4101",
    "data-name": "Line 4101",
    x2: 91.819,
    transform: "translate(923.354 457.167)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4102",
    "data-name": "Line 4102",
    x2: 172.364,
    transform: "translate(883.081 493.568)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4103",
    "data-name": "Line 4103",
    x2: 172.364,
    transform: "translate(883.081 517.475)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4104",
    "data-name": "Line 4104",
    x2: 87.246,
    transform: "translate(883.081 541.38)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142",
    transform: "translate(960.363 583.554)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_4105",
    "data-name": "Line 4105",
    y1: 23.925,
    transform: "translate(17.799)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4106",
    "data-name": "Line 4106",
    y1: 23.925,
    transform: "translate(0)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_68446",
    "data-name": "Path 68446",
    d: "M1866.241,161.966a40.478,40.478,0,0,0,40.477,40.477",
    transform: "translate(-789.17 240.516)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68447",
    "data-name": "Path 68447",
    d: "M1666.509,172.5s-24.718-.725-48.624-33.684",
    transform: "translate(-805.059 239.034)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68448",
    "data-name": "Path 68448",
    d: "M1732.574,168.239s10.547-13.85,34.41-13.85,34.409,13.85,34.409,13.85",
    transform: "translate(-797.721 240.031)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2143",
    "data-name": "Group 2143",
    transform: "translate(921.097 374.048)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 5.014,
    cy: 5.014,
    r: 5.014,
    transform: "translate(0 0)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 5.014,
    cy: 5.014,
    r: 5.014,
    transform: "translate(86.303 0)",
    fill: "#586973"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1391",
    "data-name": "Rectangle 1391",
    width: 149.409,
    height: 83.669,
    rx: 12,
    transform: "translate(799.354 201.892) rotate(-6.31)",
    fill: "#f2163e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4107",
    "data-name": "Line 4107",
    x1: 23.708,
    y1: 214.386,
    transform: "translate(793.501 204.999)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1392",
    "data-name": "Rectangle 1392",
    width: 149.409,
    height: 83.669,
    rx: 12,
    transform: "translate(792 191.423) rotate(-6.31)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "_404",
    "data-name": 404,
    transform: "translate(838.957 245.563)",
    fill: "#fff",
    fontSize: 44,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "404")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404Error.28e8f8cc.svg";
export { ForwardRef as ReactComponent };